import React, { useState } from "react";
import PropTypes from "prop-types";
// ui
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
// style
import { createStyles, makeStyles, styled } from "@material-ui/styles";
// utils

//
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
  })
);

const StyledListItem = styled(ListItem)(({ theme }) => ({
  "&.MuiListItem-root": {
    "& .MuiListItemSecondaryAction-root": {
      right: 0,
    },
  },
}));

const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
  "&.MuiListItemButton-root": {
    // padding: "4px 0 4px 16px",
  },
}));

const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  "&.MuiListItemText-root": {},
}));

//
const ListItemBasic = ({
  listIcon,
  textPrimary,
  textSecondary,
  listItemProps,
  listItemButtonProps,
  listItemTextProps,
  sx,
}) => {
  // style
  const classes = useStyles();
  // props
  // const { letter } = avatarProps;

  // local state

  const getSx = () => {
    if (sx) return sx;
    return {};
  };

  return (
    <StyledListItem disablePadding {...listItemProps} sx={getSx()}>
      {listIcon && textPrimary === "啟用事件分類功能" && (
        <ListItemIcon sx={{ minWidth: "auto" }}>{listIcon}</ListItemIcon>
      )}
      <StyledListItemButton
        {...listItemButtonProps}
        sx={{
          "& .MuiListItemText-primary": {
            width: "fit-content",
            borderBottom:
              listIcon?.props?.children?.[0]?.props?.checked &&
              textPrimary === "啟用事件分類功能"
                ? "0.5px solid #ffffff"
                : "none",
          },
          pointerEvents:
            textPrimary === "啟用事件分類功能" &&
            !listIcon?.props?.children?.[0]?.props?.checked
              ? "none"
              : "auto",
        }}
      >
        {listIcon && textPrimary !== "啟用事件分類功能" && (
          <ListItemIcon>{listIcon}</ListItemIcon>
        )}
        <StyledListItemText
          primary={textPrimary}
          secondary={textSecondary}
          {...listItemTextProps}
        />
      </StyledListItemButton>
    </StyledListItem>
  );
};

ListItemBasic.propTypes = {
  listIcon: PropTypes.node,
  textPrimary: PropTypes.node,
  textSecondary: PropTypes.node,
  listItemProps: PropTypes.objectOf(PropTypes.any),
  listItemButtonProps: PropTypes.objectOf(PropTypes.any),
  listItemTextProps: PropTypes.objectOf(PropTypes.any),
  sx: PropTypes.objectOf(PropTypes.any),
};

ListItemBasic.defaultProps = {
  listIcon: null,
  textPrimary: "",
  textSecondary: "",
  listItemProps: {},
  listItemButtonProps: {},
  listItemTextProps: {},
  sx: {},
};

export default ListItemBasic;
